export default {
  ADMIN_GROUP_PAYMENT_INFO_REJECT_KEY: "reject_payment_info",

  // Admin Panel approve and reject from table
  ADMIN_REJECT_VIDEO_COURSE: "reject_video_course",
  ADMIN_APPROVE_VIDEO_COURSE: "approve_video_course",

  // Admin Panel approve and reject from playlist detail page
  ADMIN_REJECT_PLAYLIST_DETAIL_VIDEO_COURSE:
    "reject_playlist_detail_video_course",
  ADMIN_APPROVE_PLAYLIST_DETAIL_VIDEO_COURSE:
    "approve_playlist_detail_video_course",

  // Admin Panel approve and reject from video detail page
  ADMIN_REJECT_VIDEO_DETAIL_VIDEO_COURSE: "reject_video_detail_video_course",
  ADMIN_APPROVE_VIDEO_DETAIL_VIDEO_COURSE: "approve_video_detail_video_course",

  ADMIN_GROUP_PAYMENT_INFO_CONFIRM_KEY: "approve_payment_info",
  ADMIN_RELOAD_TEAM_LIST: "admin_reload_team_list",
  UPDATE_VIDEO_PLAYLIST: "update_video_or_playlist",
  DELETE_VIDEO: "delete_video",
  DELETE_PLAYLIST: "delete_playlist",
  RELOAD_PLAYLIST_DETAIL_PAGE: "reload_playlist_detail_page",
  RELOAD_PLAYLIST_DETAIL_PAGE_VIDEOS: "reload_playlist_detail_page_videos",
  RESUBMIT_PLAYLIST: "resubmit_playlist",
  PLAYLIST_VIDEO_PAGE_UPDATE: "playlist_video_page_update",
  PLAYLIST_RESUBMIT_VIDEO_DETAIL_PAGE: "playlist_resubmit_video_detail_page",
  VIDEO_RESUBMIT_VIDEO_DETAIL_PAGE: "video_resubmit_video_detail_page",
  VIDEO_DETAIL_PAGE_UPDATE: "video_detail_page_update",
  DELETE_VIDEO_DETAIL_PAGE: "delete_video_detail_page",
};
